import pako from "pako";

const decompressData = base64Data => {
    try {
        const binaryString = Buffer.from(base64Data, "base64").toString(
            "binary"
        );
        const compressedData = new Uint8Array(
            binaryString.split("").map(char => char.charCodeAt(0))
        );
        const decompressedData = pako.inflate(compressedData, { to: "string" });
        return JSON.parse(decompressedData);
    } catch (error) {
        console.error(error);
        return null;
    }
};

export function setLoading(state, value) {
    state.loading = value;
}

export function setAllColumns(state, value) {
    state.allColumns = value;
}

export function resetParamsFile(state, value) {
    state.paramsFile.file = null;
}

export function setIsShoppingRole(state, value) {
    state.isShoppingRole = value;
}

export function setProductsPrices(state, data) {
    const dataParse = decompressData(data);

    if (dataParse) {
        const { products, prices, listPrices } = dataParse;

        const pricesMap = prices.reduce((map, price) => {
            if (!map[price.product_id]) {
                map[price.product_id] = {};
            }
            map[price.product_id][price.code_parameter] = price.price;
            return map;
        }, {});

        const updatedProducts = products.map(product => {
            const productPrices = pricesMap[product.id] || {};
            return {
                ...product,
                ...productPrices
            };
        });

        const columns = listPrices.map(item => ({
            width: 170,
            minWidth: 170,
            resizable: true,
            sortable: true,
            filter: true,
            fullName: item.name_parameter,
            isListPrice: true,
            headerName: `${item.code_parameter} - ${item.name_parameter}`,
            field: item.code_parameter.toString(),
            valueFormatter: params => {
                const value = params.value;
                if (value != null && !isNaN(value)) {
                    return new Intl.NumberFormat("es-CO", {
                        style: "currency",
                        currency: "COP",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    }).format(Math.floor(value));
                } else {
                    return "$ 0";
                }
            }
        }));

        state.productsPrices = updatedProducts;
        state.columnsPrices = columns;
    }
}



// WEBPACK FOOTER //
// ./src/modules/product-pricing/mutations.js